import React, { Component } from "react";
import backlogo from '../../assets/images/svg/Back.svg'
import { Link } from 'react-router-dom';
import Password from "./password";
import Billing from "./billing";
import { connect } from 'react-redux';
import Profile from "./Profile";
import { setloginSubscriptionDetail } from "../../reducers/counterSlice";

const mapStateToProps = (state) => {
  return {
    reduxData: state.counterSlice
  };
};

const mapDispatchToProps = {
  setloginSubscriptionDetail
};
class ProfileEdit extends Component {
  constructor(props) {
    super(props);

    // Parse query parameters from URL
    const searchParams = new URLSearchParams(props?.location?.search);
    const paramFromUrl = searchParams.get('param');

    // Prioritize URL query param over location.state
    const selectedTab = paramFromUrl || props?.location?.state?.param || 'profile';

    this.state = {
      selectedTab: selectedTab,
      userName: props?.reduxData?.loginDetails?.user?.username,
      email: props?.reduxData?.loginDetails?.user?.email,
      subscriptionPlan: '',
    };

  }

  componentDidMount() {

    const loginSubs = this.props?.reduxData?.loginSubscriptionDetail;
    const activeSubscription = Array.isArray(loginSubs)
      ? (loginSubs.find(item => item.attributes?.active === true) || { id: 0 })
      : { id: 0 };

    this.setState({ subscriptionPlan: activeSubscription?.attributes?.plan })
  }

  handleTabChange = (tab) => {
    this.setState({ selectedTab: tab });
  };

  setloginSubscriptionDetail = (data) => {
    this.props?.setloginSubscriptionDetail(data)
  }
  render() {
    const { selectedTab, userName, email } = this.state;


    return (
      <>
        <div className="">
          <div className="row">
            <div className="col-lg-3 col-md-4 col-sm-12 mb-3">
              <div className="card card-cancerType">
                <div className="card-body">
                  <Link className="btn-link-primary" to={{ pathname: '/app/dashboard' }}>
                    <div className="d-inline-flex">
                      <img src={backlogo} alt="Back" />
                      <span className="ms-1" style={{ color: '#333333', fontWeight: 400 }}>Back</span>
                    </div>
                  </Link>
                  <div className="Profile-details">
                    <div className="top-section-profile-details d-flex">
                      <div className="userNameInitial">
                        <div className="header-rightContent-userNameInitial">{userName ? userName.substring(0, 1) : "?"}</div>
                      </div>
                      <div className="user-info-text">
                        <div className="name-profile-details">{userName}</div>
                        <div className="email-section-profile-details" title={email}>{email}</div>
                      </div>
                    </div>
                  </div>
                  <div className="d-grid gap-1 mt-3">
                    <div
                      className={`tabProfileEdit ${selectedTab === 'profile' ? 'active' : ''}`}
                      onClick={() => this.handleTabChange('profile')}>
                      Profile
                    </div>
                    <div
                      className={`tabProfileEdit ${selectedTab === 'password' ? 'active' : ''}`}
                      onClick={() => this.handleTabChange('password')}>
                      Password
                    </div>
                    <div
                      className={`tabProfileEdit ${selectedTab === 'billing' ? 'active' : ''}`}
                      onClick={() => this.handleTabChange('billing')}>
                      Billing
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-9 col-md-8 col-sm-12 mb-3">
              <div className="card card-cancerType" style={{ backgroundColor: '#ffffff', minHeight: '75vh' }}>
                <div className="card-body card-body-cancerType d-grid gap-2" >
                  {selectedTab === 'profile' && <Profile />}
                  {selectedTab === 'password' && <Password />}
                  {selectedTab === 'billing' && <Billing history={this.props.history} loginSubscriptionDetail={this.props.reduxData?.loginSubscriptionDetail} loginDetails={this.props.reduxData?.loginDetails} setloginSubscriptionDetail={this.setloginSubscriptionDetail} />}
                </div>

              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileEdit);

